import {Injectable} from '@angular/core';
import {PagingApiService} from '@abstract/paging-api.service';
import {EquipmentCardInterfaces} from '@namespaces/equipment.namespace';

/**
 * API технических карт
 */
@Injectable()
export class TechnicalDeviceTechnicalCardApiService extends PagingApiService<EquipmentCardInterfaces.Card.ListItem> {
    baseUrl = 'technical-card';

    technicalCardId: number;

    /**
     * @TODO вынести прочие API пагинации данного модуля в отдельные расширения PagingApiService в отдельных сервисах
     */
    get pagingUrl(): string {
        return `${this.baseUrl}/${this.technicalCardId}/equipment-card-pages`;
    }

    defaultItemsPerPage = 10;

    /**
     * Путь до получения списка подписантов
     * @param cardId
     */
    getSignersSpecialistsListPath(cardId: number): string {
        return `${this.baseUrl}/${cardId}/signers-specialists`;
    }

    /**
     * Путь до получения данных документа техкарты
     * @param cardId
     */
    getDocumentPath(cardId: number): string {
        return `${this.baseUrl}/${cardId}/document`;
    }

    /**
     * Путь для удаления документа техкарты
     * @param cardId
     */
    getRemoveDocumentPath(cardId: number): string {
        return `${this.baseUrl}/${cardId}/remove-document`;
    }
}
